import pkg from '../package.json';
import { ReactIntegration, createReactRouterV6DataOptions } from '@grafana/faro-react';
import { getWebInstrumentations, initializeFaro } from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';
import { matchRoutes } from 'react-router';

const faroCollectorUrl = process.env.REACT_APP_FARO_COLLECTOR_URL;
const faroEnv = process.env.REACT_APP_FARO_ENV || 'development';
const apiOrigin = process.env.REACT_APP_API_ORIGIN;

if (faroCollectorUrl) {
  initializeFaro({
    url: faroCollectorUrl,
    app: {
      name: 'pastime-frontend',
      version: pkg.version,
      environment: faroEnv
    },
    instrumentations: [
      ...getWebInstrumentations({
        captureConsole: true
      }),
      new TracingInstrumentation({
        instrumentationOptions: {
          propagateTraceHeaderCorsUrls: apiOrigin ? [new RegExp(apiOrigin)] : []
        }
      }),
      new ReactIntegration({
        router: createReactRouterV6DataOptions({ matchRoutes })
      })
    ]
  });
}
